// @param {object} shareableLink - can be null or an object that contains link and text strings.
//    @param {string} href - share url
//    @param {string} text - share text
//    Example: { href: 'url', text: 'link text'}
export const setShareableLink = (state, shareableLink) => {
  return { shareableLink };
};
